module.exports = __webpack_public_path__ + "media/img/pages/companies/uni_basel-09794b2dd8651df967ae71496265af58.png";